import { memo } from 'react';

const shimmer = `
  relative overflow-hidden bg-slate-100
  before:absolute before:inset-0
  before:-translate-x-full
  before:animate-[shimmer_1.6s_infinite]
  before:bg-gradient-to-r
  before:from-transparent
  before:via-white/60
  before:to-transparent
`;

const TemplateCardSkeleton = memo(function TemplateCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl border-2 border-slate-100 overflow-hidden">
      {/* Thumbnail skeleton */}
      <div className={`aspect-video w-full ${shimmer}`}>
        {/* badge placeholders */}
        <div className="absolute top-2.5 left-2.5 flex items-center gap-1.5 z-10">
          <div className="w-16 h-5 bg-slate-200 rounded-lg"></div>
          <div className="w-12 h-5 bg-slate-200 rounded-lg"></div>
        </div>
        <div className="absolute top-2.5 right-2.5 z-10">
          <div className="w-20 h-5 bg-slate-200 rounded-md"></div>
        </div>
      </div>

      {/* Info skeleton */}
      <div className="p-4">
        {/* Title */}
        <div className="mb-2 space-y-1.5">
          <div className={`h-4 w-4/5 rounded-lg ${shimmer}`}></div>
          <div className={`h-4 w-3/5 rounded-lg ${shimmer}`}></div>
        </div>
        {/* Description */}
        <div className="space-y-1.5 mb-3">
          <div className={`h-3 w-full rounded ${shimmer}`}></div>
          <div className={`h-3 w-5/6 rounded ${shimmer}`}></div>
        </div>
        {/* Footer row */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`h-3 w-16 rounded ${shimmer}`}></div>
            <div className="flex gap-1">
              {[0, 1, 2, 3].map(i => (
                <div key={i} className={`w-3 h-3 rounded-full ${shimmer}`}></div>
              ))}
            </div>
          </div>
          <div className="flex gap-1">
            <div className={`h-5 w-14 rounded-full ${shimmer}`}></div>
            <div className={`h-5 w-12 rounded-full ${shimmer}`}></div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default TemplateCardSkeleton;
